import React, { useEffect, useState } from 'react';
import { Toast } from 'antd-mobile';
import DocumentMeta from 'react-document-meta';
import request from '../../shared/request';
import SupportHeader from '../components/support-header';
import SupportFooter from '../components/support-footer';
import { formatDate, statusText, priorityText, isClosed } from './_ticket';

const buildDetailUrl = (id) => {
  const qs = window.location.search.startsWith('?') ? window.location.search.slice(1) : '';
  return `/app/support-ticket-detail?id=${id}${qs ? '&' + qs : ''}`;
};

const TicketItem = ({ ticket, onClick }) => (
  <div className={`ticket-item ${isClosed(ticket) ? 'closed' : 'open'}`} onClick={onClick}>
    <div className="ticket-header">
      <div className="ticket-id">#{ticket.id}</div>
      <div className={`ticket-status status-${ticket.status}`}>{statusText(ticket.status)}</div>
    </div>
    <div className="ticket-subject">{ticket.subject}</div>
    <div className="ticket-meta">
      <div className="ticket-date">{formatDate(ticket.created_at)}</div>
      <div className="ticket-priority">优先级: {priorityText(ticket.priority)}</div>
    </div>
    {ticket.localData && (
      <div className="ticket-device">
        {ticket.localData.device}:{ticket.localData.appVersion} | {ticket.localData.mode}
      </div>
    )}
  </div>
);

const SupportTickets = (props) => {
  const [loading, setLoading] = useState(true);
  const [tickets, setTickets] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, perPage: 20, total: 0, totalPages: 0 });

  const loadTickets = async (page = 1) => {
    setLoading(true);
    const response = await request.call('getUserTickets', { query: { page, perPage: 20 } });
    setLoading(false);
    if (response.code !== 0) {
      return Toast.fail(response.message || '获取工单列表失败', 1);
    }
    setTickets(response.data.tickets);
    setPagination({
      page: response.data.page,
      perPage: response.data.perPage,
      total: response.data.total,
      totalPages: response.data.totalPages,
    });
  };

  const loadMore = () => {
    if (pagination.page < pagination.totalPages) {
      loadTickets(pagination.page + 1);
    }
  };

  useEffect(() => {
    loadTickets();
  }, []);

  const meta = {
    title: '我的工单',
    description: '',
    meta: { charset: 'utf-8', name: { keywords: '' } },
  };

  return (
    <DocumentMeta {...meta}>
      <SupportHeader />
      <div className="support-container support-container-content">
        <div className="navbar">
          <span className="back-btn" onClick={() => props.history.goBack()}>
            <i className="ri-arrow-left-line" />
          </span>
          <span className="title">我的工单</span>
          <span className="add-btn" onClick={() => props.history.push('/app/support')}>
            <i className="ri-add-line" />
          </span>
        </div>

        <div className="content support-tickets-content">
          <div className={`tickets-list ${loading ? 'block-loading' : ''}`}>
            <div className="loading">
              <i className="ri-loader-4-line" />
            </div>

            {!loading && tickets.length === 0 && (
              <div className="empty-state">
                <i className="ri-file-list-line" />
                <p>暂无工单记录</p>
                <button onClick={() => props.history.push('/app/support')}>
                  提交新工单
                </button>
              </div>
            )}

            {tickets.map((ticket) => (
              <TicketItem
                key={ticket.id}
                ticket={ticket}
                onClick={() => props.history.push(buildDetailUrl(ticket.id))}
              />
            ))}

            {pagination.page < pagination.totalPages && (
              <div className="load-more">
                <button onClick={loadMore} disabled={loading}>
                  {loading ? '加载中...' : '加载更多'}
                </button>
              </div>
            )}

            {tickets.length > 0 && (
              <div className="tickets-summary">
                共 {pagination.total} 个工单
              </div>
            )}
          </div>
        </div>
      </div>
      <SupportFooter />
    </DocumentMeta>
  );
};

export default SupportTickets;
